import React, { useMemo } from "react";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import { useSelector } from "react-redux";

const DomainNameLogo = () => {
    const { agentPortalName, guestPortalName } = useSelector((state) => state.language);
    const companyName = useMemo(() => {
        return GLOBAL_MEETING_DATA.isAgent ? agentPortalName : guestPortalName;
    }, [agentPortalName, guestPortalName]);
    return (
        <div className='call-branding-detail'>
            {GLOBAL_MEETING_DATA.companyLogo && (
                <div className='domain-logo'>
                    <img className='domain-img' src={GLOBAL_MEETING_DATA.companyLogo} alt='Domain_logo' />
                </div>
            )}
            {companyName && <div className='domain-name'>{companyName}</div>}
        </div>
    );
};

export default DomainNameLogo;
